import request from "superagent";
import API from "./API";
import session from "../config/session";

class AppService {
  static getInfo() {
    return request.get("/info").accept("json").query();
  }

  static getApiConfig() {
    return API.get("config", null, session.token);
  }
}

export default AppService;
